module.exports = __webpack_public_path__ + "img/pc-button-large-04.fdb70934.svg";